export default {
  common: {
    email: '邮箱',
    phone: '电话',
    phoneNumber: '电话号码',
    countrySelect: '选择国家',
    countryUnmodifiedNote: '注册后国家不可修改',
    next: '下一步',
    back: '返回',
    attention: '注意',
    cancel: '取消',
    confirm: '确认',
    modify: '修改',
    ignore: '忽略',
    firstName: '名字',
    middleName: '中间名',
    lastName: '姓氏',
    gender: '性别',
    male: '男',
    female: '女',
    birthday: '生日',
    graphicCode: '图形验证码',
    emailCode: '邮箱验证码',
    smsCode: '短信验证码',
    smsVerificationCode: '短信验证码',
    bind: '绑定',
    send: '发送',
    resend: '重新发送',
    address: '地址',
    done: '完成',
    systemMessage: '系统消息',
    setting: '设置',
    submit: '提交',
    language: '语言',
    edit: '编辑',
    delete: '删除'
  },
  account: {
    account: '账户',
    nickname: '昵称',
    id: 'ID',
    basicInfo: '基础等级',
    placeholder: '请输入',
    completed: '已完成',
    semiInfo: '半验证',
    fullyInfo: '全验证',
    basicTab: '基础',
    advancedTab: '进阶',
    linkedAccount: '关联提现账户',
    accountSecurity: 'MetWallet账户及安全',
    logout: '退出',
    semiToast: '请完成基础等级验证',
    fullyToast: '请完成基础等级\n及半验证',
    quickLoginTitle: '快速登录',
    cancelQuickLogin: '确定要停用快速登录吗？'
  },
  accountSecurity: {
    title: '账户及安全',
    payPwd: '支付密码',
    loginPwd: '登录密码',
    changeEmail: '修改邮箱',
    changePhone: '修改手机号',
    changePayPwd: '修改支付密码',
    changeLoginPwd: '修改登录密码',
    bindEmail: '绑定邮箱',
    bindEmailNote: '通过邮箱验证进行绑定',
    bindEmailPlaceholder: '输入您要绑定的邮箱',
    smsBindNote: '通过短信验证进行绑定',
    bindPhone: '绑定手机号',
    smsAuthentication: '短信验证',
    emailAuthentication: '邮箱验证',
    phoneVerificationNote: '请先通过当前手机号验证',
    bindPhonePlaceholder: '输入您要绑定的手机号',
    verificationWrongToast: '请检查您的验证码',
    phoneNumberEmptyToast: '请填写手机号',
    verificationCodeEmptyToast: '请填写验证码',
    wrongCodeToast: '验证码错误',
    changeNote: '请通过验证进行修改。',
    newEmailVerification: '新邮箱验证',
    newEmailPlaceholder: '输入您的新邮箱',
    change: '修改',
    emailLowercaseToast: '邮箱必须为小写。',
    newEmailEmptyToast: '请填写新邮箱',
    changeSuccessToast: '修改成功',
    phonePlaceholder: '输入手机',
    currentEmail: '当前电子邮件',
    passCurrentEmailVerificationFirst: '先通过当前电子邮件验证',
    currentEmailVerification: '当前电子邮件验证',
    smsVerification: '短信验证',
    currentPhoneNumber: '当前手机号',
    currentPhoneVerification: '当前手机验证',
    currentEmailAddress: '当前邮箱地址',
    phoneVerification: '电话验证',
    enterVerificationCode: '输入验证码',
    newPhoneNumber: '新手机号码',
    newEmail: '新邮箱'
  },
  withdrawAccount: {
    selectAccountType: '选择账户类型',
    noBasicLevelVerificationDialog: '绑定提现方式前，请先完成基础等级验证。',
    bindNote: '请填写正确的账户信息，否则您的提现将受到影响。',
    bindBankAccount: '绑定银行账户',
    bindMobileMoneyAccount: '绑定移动货币账户',
    fieldEmptyToast: '{0}为必填项',
    fieldLengthToast: '{0}必须至少包含{1}个字符',
    bindBankRepeatToast: '请勿重复绑定同个银行账户！',
    accountName: '账户名称',
    ifscCode: 'IFSC代码',
    accountEmptyToast: '账户为必填项',
    accountNameEmptyToast: '账户名称为必填项',
    phoneEmptyToast: '电话为必填项',
    emailEmptyToast: '邮箱为必填项',
    ifscCodeEmptyToast: 'IFSC代码为必填项',
    ifscCodeLengthToast: 'IFSC代码必须为11位数字',
    bindIMPSRepeatToast: '请勿重复绑定同一个IMPS账户！',
    bindNote2: '请填写您正确的TRC-20地址，地址错误将导致款项丢失，对此我们不承担任何责任。',
    usdtAddress: 'USDT地址(TRC-20):',
    minimumLimit: '每笔提现最低金额：$10',
    usdtFee: '费用：以实际费用为准',
    registerGcash: '如果您没有Gcash账户，请点击此处注册。',
    registerEpay: '如果您没有Epay账户，请点击此处注册。',
    bindThirdPartyTitle: '绑定{0}账户',
    wrongAccountToast: '账户错误',
    accountFormatToast: '账户格式不正确',
    bindThirdPartyFailedToast: '{0}绑定失败',
    queryFailedToast: '查询失败。',
    editFailedToast: '编辑失败。',
    add: '添加',
    confirmEditDialog: '您确定要编辑帐户{0}吗？',
    payPwdRequireDialog: '添加帐户前，请设置6位付款密码。',
    unbindFailedToast: '解绑失败',
    cashOutSuccessNote: '预计到达时间：7 个工作日内',
    requestSubmitted: '提现申请已提交',
    amountLimitToast1: '提现金额必须≥$40.00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: '提现金额必须≥${0}.00',
    // eslint-disable-next-line no-template-curly-in-string
    recommendAmountNote: '提示：提现前累计金额到${0}可有效节省手续费',
    amountNotEnoughToast: '提现金额不足',
    exceedingLimitToast1: '今日提现金额已达上限',
    exceedingLimitToast2: '今日提现金额已达上限，是否要完成高级认证以提升限额？',
    restrictedCountriesPayPalAccountToast: '请勿使用受限制国家的PayPal账户，否则会导致您的Arripay被冻结',
    withdrawMinimumToast: '每笔提现最低金额：$40',
    bankNotAvailableToast: '该银行已不再可用，请绑定其他银行',
    usdtAccountInvalidToast: '此USDT账户无法提现，请使用新账户提现。',
    noPayPwdToast: '提现前请设置6位支付密码',
    editBankAccount: '编辑银行账户',
    accountPlaceholder: '输入您的账户',
    trc20Placeholder: '输入TRC-20地址',
    accountRepeatToast: '与当前密码相同。',
    unbindBankCardConfirmDialog: '确定解绑银行卡{0}吗？',
    unbindMobileMoneyAccountConfirmDialog: '确定解绑移动钱包账户{0}吗？',
    unbindAccountConfirmDialog: '确定解绑账户{0}吗？',
    availableBalance: '可用余额{0}',
    estimatedFee: '预估费用',
    submitFailToast: '提交失败',
    disabledMethodToast: '该渠道暂时不可用',
    channelUnavailableTitle: '渠道不可用',
    channelUnavailableNote: '该提现渠道暂时无法使用，请尝试其他方式。',
    channelUnavailableOk: '确定',
    bankTransferUnavailableTitle: '银行转账不可用',
    bankTransferUnavailableNote: '您的账户目前无法使用银行转账。请使用 Epay 提现。',
    channelMaintenanceTitle: '渠道维护中',
    channelMaintenanceNote: '该提现渠道正在维护中，请尝试其他方式。',
    bankInfoUpdateTitle: '请更新银行信息',
    bankInfoUpdateNote: '因银行政策调整，请更新您的银行信息后继续。',
    bindEpay: '绑定 Epay',
    useEpay: '使用 Epay',
    iMPSMaxLimitToast: '该渠道单笔最大提现额度为$260',
    linkedAccount: '已添加账户',
    otherAccounts: '其他可添加账户',
    withdrawTo: '转出至',
    withdrawAmount: '转出金额',
    withdrawable: '可提现的',
    documentIdToast: '身份证号只能包含数字',
    noAvailableMethodNote: '无可用的提现方式',
    channelFee: 'Fee：{0}',
    recommended: '推荐'
  },
  paymentCode: {
    changePayPwd: '修改支付密码',
    setPayPwd: '设置支付密码',
    setPayPwdNote: '请设置6位支付密码',
    reenterPayPwdNote: '重新输入',
    verificationNote: '请通过验证后进行设置',
    verifyToSetPayPwd: '验证以设置支付密码。',
    emailVerification: '邮箱验证',
    inconsistentPasswordToast: '密码不一致',
    payPwdNote: '请输入支付密码',
    payPwdFormatToast: '支付密码为6位数字',
    payPwdWrongToast: '支付密码错误',
    payPwdVerificationFailToast: '支付密码验证失败！',
    successToast: '设置\n成功'
  },
  authorize: {
    requirement: '{0}需要获取您MetWallet{1}的以下信息，才能为您提供相关服务。如昵称、头像、性别等。',
    authorize: '授权',
    switchAccount: '切换账户',
    goToMetWallet: '前往MetWallet',
    notMatchTips: '操作失败。您只能使用已绑定的 MetWallet 账户启用快速登录'
  },
  basicLevel: {
    namePlaceholder: '无符号、数字',
    verification: '验证',
    whatsAvailable: '可用内容',
    cashOut: '提现',
    withdrawTitle: '提现',
    withdrawLimit: '$50/天',
    fillInfoHint: '填写信息以便提现',
    identityVerification: '身份验证',
    withdrawalAccountStep: '提现账户',
    nameMatchNote: '请确保姓名与银行卡一致，否则提现将失败。',
    nameFieldPlaceholder: '姓名',
    birthdayPlaceholder: '出生日期',
    addressPlaceholder: '请输入地址',
    emailRegisteredNote: '该邮箱已被注册，请更换一个。',
    basicLevelNote: '请填写真实个人信息，提交后不可修改。信息错误可能导致提现失败。',
    fieldEmptyToast: '请填写所有必填字段。',
    successToast: '保存\n成功',
    failToast: '保存失败',
    confirmDialog: '请确保输入真实的个人信息。错误信息可能导致提现失败。',
    birthdayFormatToast: '生日字段格式不正确',
    verificationCodeError: '验证码错误',
    verificationCodeEmpty: '验证码为空',
    noEmailCodeToast: '请获取邮箱验证码',
    confirmInfoTitle: '确认信息',
    confirmInfoWarning: '*姓名必须与银行卡完全一致，否则可能导致提现失败。提交后不可修改。',
    saveCountdown: '保存（{0}秒）',
    saveInfo: '保存',
    checkDialogTitle: '检查您的信息',
    checkDialogContent: '为成功提现，请检查您的信息。错误信息可能导致提现失败。',
    check: '检查'
  },
  semiVerified: {
    uploadPhotoId: '上传带照片的身份证件',
    photoId: '带照片的身份证件',
    resubmit: '重新提交',
    limit: '每日5000美元',
    uploading: '上传中...',
    notUploadProofToast: '请上传身份证件证明'
  },
  fullyVerified: {
    frontOfId: '证件正面',
    backOfId: '证件背面',
    uploadIdFront: '上传证件正面',
    uploadIdBack: '上传证件背面',
    withdrawDailyHint: '填写信息以便提现 > {0} /天',
    notUploadIdToast: '请上传证件正反面',
    proofTitle: '居住证明文件',
    acceptableProof: '可接受的居住证明是：',
    acceptableProof1: '银行账户对账单',
    acceptableProof2: '公用事业账单（电费、水费、网络费等）',
    acceptableProof3: '政府签发的文件（税务报表、居住证等）',
    unacceptableProof: '我们不能接受您提交的身份证件上的地址作为有效的居住证明。',
    limit: '每天 10,000 美元',
    notUploadToast: '请上传居住证明文件',
    incorrectFormatToast: '请上传 jpg/png/jpeg 图片'
  },
  loginAndRegister: {
    pwd: '密码',
    lastLogin: '上次登录',
    moreOptions: '更多选项',
    agreeCheckboxContent: '同意{0}和{1}',
    userAgreement: '用户协议',
    privacyPolicy: '隐私政策',
    notAgreeToast: '同意用户协议和隐私政策',
    forgotPassword: '忘记密码',
    linkedMail: '关联邮箱',
    verificationCode: '验证码',
    newPwd: '新密码',
    repeatPwd: '重复密码',
    confirmPwd: '确认密码',
    noLinkedEmailToast: '您的账户没有关联邮箱',
    unregisteredToast: '此号码未注册',
    pwdFormatToast: '密码格式错误',
    resetSuccessToast: '重置\n成功',
    pwdNotMatchToast: '密码两次不匹配',
    emailFormatToast: '电子邮件格式错误',
    phoneNumberFormatToast: '电话号码格式错误',
    invalidAreaCodeToast: '无效的区号',
    login: '登录',
    pwdLogin: '通过密码登录',
    emailCodeLogin: '通过电子邮件验证码登录',
    smsLogin: '通过短信登录',
    verifyEmail: '验证电子邮件',
    verifyPhone: '验证电话',
    accountDangerDialog: '您的帐户已被检测到存在风险。请重新验证您的帐户，否则您的帐户将无法继续使用。',
    sendEmailCodeDialog: '我们已将验证码发送到您的{0}电子邮件。请输入验证码。',
    sendSmsCodeDialog: '我们已将验证码发送到您的{0}电话。请输入验证码。',
    graphicCodeEmptyToast: '请输入图形验证码',
    countryUnselectToast: '请先选择您所在的国家/地区',
    unsupportedLoginTypeToast: '不支持的登录类型',
    pwdWrongLimitOverDialog: '密码输入错误3次。请使用短信验证码登录。',
    loginFailedToast: '登录失败',
    signIn: '登录',
    pwdPlaceholder: '输入密码',
    pwdNote: '输入8-16位字母和数字组合',
    reenterPwdPlaceholder: '重新输入密码',
    reenterPwdNote: '请重新输入密码',
    createAccount: '创建账户',
    chooseCountryNote: '请选择国家',
    pwdInconsistentToast: '与您之前输入的密码不一样',
    createSuccessToast: '创建\n成功',
    registerFailToast: '注册失败',
    userNotExistToast: '用户不存在',
    phoneIncorrectToast: '请检查手机',
    userExistToast: '用户已存在',
    countryCodeRepeatToast: '请勿重复输入国家码！',
    logoutDialog: '确定退出吗？',
    pwdRequirement: '密码必须为8到16个字符，包含字母和数字',
    signup: '注册',
    registerSuccessToast: '注册\n成功',
    oldPwdErrorToast: '请检查旧密码'
  },
  checkUserInfo: {
    title: '管理中心',
    emptyInfoNote: '无当前账户信息，请检查您需要验证的MetWallet账户。',
    infoNote: '这是您的验证信息。',
    lastSuccessWithdrawal: '最近一次成功提现',
    copyBtn: '复制',
    successToast: '复制成功！',
    failToast: '复制失败！'
  },
  country: {
    title: '选择地区',
    popular: '热门'
  },
  documentDetails: {
    title: '文件详情',
    contract: '合同',
    goToSign: '去签字',
    download: '下载',
    upload: '上传',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., 仅限文件。',
    contentEmptyToast: '请输入内容',
    placeOfBirth: '出生地',
    occupation: '职业',
    fileForm: '(文件形式)',
    proofOfAddress: '英文住址证明',
    residenceDoc: '居住文件',
    textForm: '(文本形式)',
    contractAgent: '合同代理人',
    contractPayslip: '合同工资单',
    uncompletedToast: '请填写后提交',
    successToast: '提交成功',
    undefinedFileTypeToast: '未定义文件上传类型',
    uploadFailToast: '上传失败'
  },
  filters: {
    amount: '数量',
    filter: '筛选条件',
    time: '时间',
    reset: '重置',
    timePickerTitle: '选择{0}时间',
    start: '开始',
    end: '结束',
    maximum: '最大值',
    minimum: '最小值'
  },
  home: {
    balance: '余额',
    transactions: '交易',
    availableBalance: '可用余额',
    noWithdrawalMethodToast: '至少需要一种提现方式。',
    linkAccount: '链接帐户',
    all: '全部',
    cashIn: '现金存入',
    loading: '加载中...',
    noMore: '没有更多交易',
    reload: '加载失败，单击重新加载',
    receivedFrom: '收到的款项',
    transferredTo: '转账至',
    fee: '转账费用',
    myEmail: '我的电子邮件',
    myPhone: '我的电话',
    invalidBasicLevelDialog:
      '由于您的姓名字段中包含符号、空格或数字，因此无法从帐户中提款。请再次填写基本信息（确保姓名中不包含符号、空格或数字，如果您没有姓氏或中间名，请留空。）',
    lackLastNameDialog: '您的姓氏未填写，这将妨碍您的提款。',
    fillIn: '填写',
    viewDetails: '查看详情',
    docReviewingDialogTitle: '请等待文件通过。',
    docReviewingDialogContent:
      '您已提交文件，但在文件通过之前您无法使用MetWallet。<br>官方工作人员将很快处理，请等待一段时间。',
    docPassedDialog: '您提交的文件已通过。<br>您现在可以正常使用MetWallet。',
    docUnqualifiedDialog: '您提交的文件不合格。<br>请提交合格的文件。',
    goToSubmit: '去提交',
    uncompletedDialog: '您必须完成它才能正常使用MetWallet',
    useMetWalletNormallyAfterPassed: '文件通过后，您即可正常使用MetWallet。',
    requireSemiVerifiedDialog: '{0}，根据银行的要求，您必须在48小时内完成半验证部分才能成功提款。',
    goToVerify: '去验证',
    emailInvalidDialog: '{0}，您的电子邮件地址与他人相同。为了保护您的隐私，请尽快输入您自己的电子邮件地址。',
    later: '稍后',
    transferRequireSemiVerifiedDialog: '转账前请完成半验证。',
    modifyBtnText: '修改我的信息',
    unmodifiedTitle: '无法修改',
    unmodifiedContent: '您有一个提现订单正在处理中，现在无法修改信息。'
  },
  signing: {
    signature: '签名',
    date: '日期',
    employeeName: '员工姓名',
    designation: '职位',
    month: '月',
    year: '年',
    earnings: '收入',
    deductions: '扣除额',
    basic: '基本及 DA(USD)',
    totalAddition: '总增加额',
    totalDeduction: '总扣除额',
    salary: '净工资',
    refNo: '参考编号',
    paymentTransferDate: '付款转账日期',
    nameOfBank: '银行名称',
    signatureOfEmployee: '员工签名',
    director: '主管',
    signNote: '请签名',
    preview: '预览',
    clear: '清除',
    save: '保存',
    noSignatureToast: '没有签名则无法保存。',
    fieldEmptyToast: '请填写所有信息。'
  },
  transactionDetail: {
    title: '交易详情',
    status: '状态',
    pending: '待处理',
    completed: '已完成',
    success: '成功',
    failed: '失败',
    cancelled: '已取消',
    onHold: '暂停',
    reason: '状态原因',
    description: '说明',
    creationDate: '创建日期',
    lastStatusDate: '最后状态日期',
    requestedAmount: '请求金额',
    receiveAmount: '收到金额',
    transferAmount: '转账金额',
    amountToPay: '应付金额',
    transferFee: '转账费',
    processingFee: '手续费',
    method: '方法',
    country: '国家',
    name: '名称',
    bankPendingText: '处于最终银行审核中',
    pendingText: '处于{0}审核中',
    chametSalary: '代理代提',
    userSalary: '主播提现',
    comm: '代理费',
    gemgalaSalary: 'Gemgala代理费'
  },
  transfer: {
    title: '至 MetWallet 账户',
    noPayPwdDialog: '转账前请设置 6 位付款密码。',
    records: '记录',
    cashInOut: '存入{0}，提出{1}',
    transfer: '转账',
    fee: '费用',
    remark: '备注',
    transferTo: '转账至{0}',
    remarkPlaceholder: '添加转账备注（100个字符以内）',
    firstNameNote: '请输入对方姓名',
    sendingAmount: '汇款金额',
    receivingAmount: '收款金额',
    transferNow: '立即转账',
    noBalanceToast: '转账金额大于余额',
    amountTooLittleToast: '转账金额不能小于$10'
  },
  bankData: {
    beneficiaryName: '受益人姓名',
    beneficiaryNamePlaceholder: '输入姓名',
    beneficiaryLastname: '受益人姓氏',
    beneficiaryLastnamePlaceholder: '输入姓氏',
    bankCode: '银行代码',
    bankCodePlaceholder: '选择银行代码',
    bankIFSCCode: '银行 IFSC 代码',
    bankIFSCCodePlaceholder: '输入银行 IFSC',
    bankAccount: '银行账户',
    bankAccountPlaceholder: '输入银行账户',
    email: '电子邮件',
    emailPlaceholder: '输入电子邮件',
    phoneNumber: '电话号码',
    phoneNumberPlaceholder: '输入电话号码',
    address: '地址',
    addressPlaceholder: '输入地址',
    city: '城市',
    cityPlaceholder: '输入城市',
    state: '州',
    statePlaceholder: '输入州',
    postCode: '邮政编码',
    postCodePlaceholder: '输入邮政编码',
    documentId: '文件 ID',
    documentIdPlaceholder: '输入文件 ID',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: '文件类型',
    documentTypePlaceholder: '选择文件类型',
    accountType: '账户类型',
    accountTypePlaceholder: '选择账户类型',
    cpfcnpjPlaceholder: '输入 CPFCNPJ',
    bankBranch: '银行分行',
    bankBranchPlaceholder: '输入银行分行',
    ribOfBankAccount: '银行账户 RIB',
    bankName: '银行名称',
    bankNamePlaceholder: '输入银行名称',
    bicCode: 'BIC 代码',
    bicCodePlaceholder: '输入 BIC 代码',
    ibanPlaceholder: '输入 IBAN',
    bankSwift: '银行 Swift',
    bankSwiftPlaceholder: '输入银行 Swift',
    name: '名称',
    documentCountry: '文件国家/地区',
    documentCountryPlaceholder: '选择文件国家/地区',
    issueDate: '文件签发日期',
    issueDatePlaceholder: '选择签发日期',
    expireDate: '文件到期日期',
    expireDatePlaceholder: '选择到期日期',
    bankBranchName: '银行分行名称',
    bankBranchNamePlaceholder: '输入分行名称',
    branchPlaceholder: '输入分行',
    gender: '性别',
    genderPlaceholder: '选择性别',
    birthday: '生日',
    birthdayPlaceholder: '选择生日',
    phone: '电话',
    bankAddress: '银行地址',
    bankAddressPlaceholder: '输入银行地址',
    bankAccountName: '银行账户名称',
    bankAccountNamePlaceholder: '输入银行账户名称',
    province: '省份',
    provincePlaceholder: '输入省份',
    postalCode: '邮政编码',
    postalCodePlaceholder: '输入邮政编码',
    savingsAccount: '储蓄账户',
    abaRoutingNumber: 'ABA 路由号码',
    englandBankAccount: '英格兰银行账户',
    bankBranch2: '银行分行',
    bankBranch2Placeholder: '仅当银行为桑坦德银行时',
    paternalName: '父亲姓名',
    paternalNamePlaceholder: '输入父亲姓名',
    passportIdNumber: '护照 ID 号',
    bankNamePlaceholder2: '选择银行名称',
    areaCode: '手机区号',
    phoneNumberNoAreaCode: '手机号 (不含区号)',
    idType: '证件类型',
    idNo: '证件号码',
    idIssueDate: '证件签发日期',
    idExpireDate: '证件有效日期',
    ibanStyleToast: '请输入以“SA”开头，长度为24个字符的内容'
  },
  rechargeAndTransfer: {
    transfer_limit_1: '你只能转账给主钻石销售代理',
    search: '搜索',
    history: '历史转账用户',
    confirm_content: '你确认要转账{0}给{1}？',
    success_content: '{0}已转账给{1}',
    purchase: '购买',
    purchase_success: '你已成功购买{0}',
    insufficient_balance: '余额不足',
    purchase_diamond: '购买钻石',
    transfer_limit_2: '转账金额需介于$10到$30,000',
    no_data: '无数据',
    invalid_number: '请输入有效数字',
    under_limit: '转账金额需不低于$10',
    over_limit: '转账金额需低于$30,000'
  },
  redesign: {
    emailPlaceholder: '输入邮箱地址',
    retrievePwd: '找回密码',
    resetPwd: '重置密码',
    newPwdPlaceholder: '输入新密码',
    reenterNewPwdPlaceholder: '重新输入新密码',
    reenterPayPwdPlaceholder: '请重新输入支付密码',
    sendToPhone: '验证码已发送至您的手机',
    sendToWhatsapp: '验证码已发送至您的 WhatsApp',
    sendToEmail: '验证码已发送至您的邮箱',
    invalidCode: '验证码无效',
    userId: '用户 ID',
    other: '其他',
    transactionRecord: '交易记录',
    bankCardInfo: '银行卡账户',
    withdrawInfo: '提现账户',
    toFillIn: '未填写',
    walletInfo: '钱包账户信息',
    toComplete: '待完善',
    verifyGuide: '完成钱包账户信息获得更多提现资格',
    verifyNote: '完成以下信息解锁每日提现 {0} 资格',
    verifyCompletedNote: '信息填写完成，获得每日 {0} 提现资格',
    continueBtnText: '继续填写',
    submitInfo: '提交信息',
    transferAmount: '转出金额',
    newEmailVerify: '新邮箱验证',
    verifyCodePlaceholder: '输入验证码',
    emailIncorrectToast: '请填写正确的邮箱地址',
    newPhone: '新手机号码',
    accountAdded: '已添加账户信息',
    accountToAdd: '其他可添加账户',
    edit: '编辑',
    enterPayPwd: '输入支付密码',
    deleteBtnText: '删除',
    transferTo: '转出至',
    withdrawable: '可提现的',
    goSet: '去设置',
    goModify: '去修改'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/zh.js